module.exports = __webpack_public_path__ + "static/media/daum_icon.352b2c49.png";